import { onMounted, inject } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { setDataLocation } from '@/utils/index.js'
import useDetectDevice from "@/hooks/useDetectDevice";
const useToExternal = () => {
  // 跳出外部系统时将条件保存
    const route = useRoute()
    const goExternal = (url) => {
        let path = route.fullPath
        setDataLocation('path', path)
        window.open(url, '_blank')
    }
    return {
        goExternal
    }
}
const useFromExternal = () => {
  const { device } = useDetectDevice()
  // 从外部系统进入时取出条件并跳转
    const router = useRouter()
    onMounted(() => {
      setTimeout(()=>{
        if (device.value === 'mb') {
          router.push('/searchJobResult')
        } else {
          // 外部跳转直接进入职位列表页
          router.push('/searchJob')
        }
      },200)
    })
}
export { useToExternal, useFromExternal }
